import auth from './auth';
import news from './news';
import speciality from './speciality';
import salon from './salon';
import resume from './resume';
import toggle from './toggle';
import adviceDetail from './adviceDetail';
import notification from './notification';
import major from './major';
export default {
    auth,
    news,
    toggle,
    resume,
    salon,
    speciality,
    adviceDetail,
    major,
    notification
};
